import { createContext } from 'react';

import type { Brand } from '~/modules/branding/types';

import { defaultBrandContext } from './defaultBrandContext';

export const BrandContext = createContext<Brand>(defaultBrandContext);

BrandContext.displayName = 'BrandContext';
